export const isDev = state => state.isDev;
export const isAdmin = state => state.isAdmin;
export const isMobile = state => state.isMobile;
export const mailTypes = state => state.mailTypes;
export const countryList = state => state.countryList;
export const currencyList = state => state.currencyList;
export const provider = state => state.provider;
export const phoneProps = state => state.phoneProps;
export const globalNotification = state => state.globalNotification;
export const popupOpen = state => state.popupOpen;
export const reminders = state => state.reminders;
export const notifications = state => state.notifications;
export const announcements = state => state.announcements;
export const apiErrors = state => state.apiErrors;
export const popupError = state => state.popupError;